import { DateInput, Select } from 'components'
import moment from 'moment'
import { SearchingSectionProps } from 'pages/Purchase/Register/types/AgedPayable'
import { useEffect } from 'react';
import { useListVendor } from '../hooks';
import { SelectOptionType } from 'types';

export const SearchingSections = ({ selected, setSelected }: SearchingSectionProps) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
//   const dateTo = new Date(year, month, 1);
  const dateTo = moment().startOf('year').format('YYYY-MM-DD');
  const dateEnd = new Date(year, month + 1, 0);

  const { dataVendor, isLoadingVendor } = useListVendor()

  const selectStatus: SelectOptionType[] = [
    { value: "1", label: "OPEN" },
    { value: "2", label: "CLOSE" },
    { value: "3", label: "CREDIT" },
  ]
  const sortedSelectVendor = dataVendor.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const sortedSelectStatus = selectStatus.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const allOption = { value: "", label: "All" };

  useEffect(() => {
    if(selected?.date_from === "") { setSelected({ ...selected, date_from: moment(dateTo).format("YYYY-MM-DD")}) }
    if(selected?.date_end === "") { setSelected({ ...selected, date_end: moment(dateEnd).format("YYYY-MM-DD")}) }

    // eslint-disable-next-line
  }, [selected])

  return (
    <section className="lg:flex overflow-x-auto">
        <div className='flex items-center w-[284px] lg:w-[250px]'>
            <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">START DATE</div>
            <DateInput
                className="!w-[150px]"
                placeholderText="Date From"
                onChange={(date) => setSelected({ ...selected, date_from: moment(date).format("YYYY-MM-DD")})}
                selected={ selected?.date_from ? moment(selected?.date_from).toDate() : null }
            />
        </div>
        <div className='flex items-center w-[284px] lg:w-[250px] mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">END DATE</div>
            <DateInput
                className="!w-[150px]"
                placeholderText="Date To"
                onChange={(date) => setSelected({ ...selected, date_end: moment(date).format("YYYY-MM-DD")})}
                selected={ selected?.date_end ? moment(selected?.date_end).toDate() : null }
            />
        </div>
        <div className='flex items-center ml-1 mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">VENDOR</div>
            <Select
                className="w-[150px]"
                placeholder="Select Location"
                isLoading={isLoadingVendor}
                value={selected?.vendor_id !== "" ? [allOption, ...sortedSelectVendor].find((item) => item.value?.toString() === selected?.vendor_id?.toString()) : allOption}
                options={[allOption, ...dataVendor]}
                onChange={(e) => setSelected({ ...selected, vendor_id: e?.value! })}
                
            />
        </div>
        <div className='flex items-center ml-1 mt-2 lg:mt-0'>
            <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">STATUS</div>
            <Select
                className="w-[150px]"
                placeholder="Select Location"
                value={selected?.bill_status !== "" ? [allOption, ...sortedSelectStatus].find((item) => item.value?.toString() === selected?.bill_status?.toString()) : allOption}
                options={[allOption, ...selectStatus]}
                onChange={(e) => setSelected({ ...selected, bill_status: e?.value! })}
            />
        </div>
    </section>
  )
}